import {createSlice} from "@reduxjs/toolkit";
import {TService} from "../service/i-service";

interface IInitialState {
  upcomingCalls: {
    id: number;
    userId: number;
    serviceId: number;
    mentor_timezone: string;
    user_timezone: string;
    booking_year: string;
    booking_month: string;
    booking_date: string;
    timeslot: string;
    endTime: string;
    email_address: string;
    first_name: string;
    last_name: string;
    amount: number;
    roomId: string | null;
    notes: string | null;
    phone_number: string;
    booking_type: string;
    is_bundle: boolean;
    statusId: number;
    reference: string;
    is_paid: boolean;
    bookingQuestions: [] | null;
    statusName: string;
    service: TService;
  }[];
  pastCalls: {
    id: number;
    userId: number;
    serviceId: number;
    mentor_timezone: string;
    user_timezone: string;
    booking_year: string;
    booking_month: string;
    booking_date: string;
    timeslot: string;
    endTime: string;
    email_address: string;
    first_name: string;
    last_name: string;
    amount: number;
    roomId: string | null;
    notes: string | null;
    phone_number: string;
    booking_type: string;
    is_bundle: boolean;
    statusId: number;
    reference: string;
    is_paid: boolean;
    bookingQuestions: [] | null;
    statusName: string;
    service: TService;
  }[];
  fetchUpcomingCallsStatus: "idle" | "pending" | "resolved" | "rejected";
  fetchPastCallsStatus: "idle" | "pending" | "resolved" | "rejected";
  mentorRescheduleCallStatus: "idle" | "pending" | "resolved" | "rejected";
  mentorCancelCallStatus: "idle" | "pending" | "resolved" | "rejected";
  message: string;
}

const initialState: IInitialState = {
  upcomingCalls: [],
  pastCalls: [],
  fetchUpcomingCallsStatus: "idle",
  fetchPastCallsStatus: "idle",
  mentorRescheduleCallStatus: "idle",
  mentorCancelCallStatus: "idle",
  message: "",
};

export const callSlice = createSlice({
  name: "call",
  initialState,
  reducers: {
    resetCallState: (state) => {
      // state.fetchUpcomingCallsStatus = "idle";
      state.mentorCancelCallStatus = "idle";
      state.mentorRescheduleCallStatus = "idle";
      state.message = "";
    },
    resetPastCallState: (state) => {
      // state.fetchUpcomingCallsStatus = "idle";
      state.fetchPastCallsStatus = "idle";
      state.pastCalls = [];
      state.message = "";
    },
    callLogoutReset: (state) => initialState,
  },
});

export const {resetCallState, resetPastCallState, callLogoutReset} = callSlice.actions;

export default callSlice.reducer;
